module.exports = __webpack_public_path__ + "img/sertifikat-4.9c6ea1f0.jpg";